import ListMembersRequest from "./ListMembersRequest"

class ListTargetPersonsRequest extends ListMembersRequest {
}

export default ListTargetPersonsRequest